module.exports = __webpack_public_path__ + "img/FeroTools.31e4bf29.png";